module.exports = {
    mapLocale: {
        'en-GB': 'uk/en',
        de: 'de/de',
        'en-EG': 'eg/en',
        'ar-EG': 'eg/ar',
        'en-US': 'us/en',
        'fr-FR': 'fr',
        'pl': 'pl',
        'ar-AE': 'arabia/ar',
        'en-AE': 'arabia/en',
        'es-PE': 'pe',
        'en-PK': 'pk',
        'sv-SE': 'se'

    },
    cookieLang: {
        'en-GB': 'en',
        de: 'de',
        'en-EG': 'en',
        'ar-EG': 'ar',
        'en-US': 'en',
        'fr-FR': 'fr',
        'pl': 'pl',
        'ar-AE': 'ar',
        'en-AE': 'en',
        'es-PE': 'es',
        'en-PK': 'en',
        'sv-SE': 'se'
    },
    siteUrl:{
        'en-EG': 'eg/en',
        'ar-EG': 'eg/ar',
        'en-AE': 'arabia/en',
        'ar-AE': 'arabia/ar',
        'es-PE': 'pe',
        'en-PK': 'pk',
        'sv-SE': 'se'
    },
    mapLangSelector: {
        'en-GB': 'Great Britain (English)',
        de: 'Germany',
        'en-EG': 'Egypt (English)',
        'ar-EG': 'Egypt (Arabic)',
        'en-US': 'United States (English)',
        'fr-FR': 'France (French)',
        'pl': 'Poland (Polish)',
        'ar-AE': 'UAE (Arabic)',
        'en-AE': 'UAE (English)',
        'es-PE': 'Peru (Spanish)',
        'en-PK': 'Pakistan (English)',
        'sv-SE': 'Sweden (Swedish)'
    },
    mapAddressCountry: {
        'en-GB': 'United Kingdom',
        de: 'Germany',
        'en-EG': 'Egypt',
        'ar-EG': 'Egypt',
        'en-US': 'United States of America',
        'fr-FR': 'France (French)',
        'pl': 'Poland (Polish)',
        'ar-AE': 'UAE (United Arab Emirates)',
        'en-AE': 'UAE (United Arab Emirates)',
        'es-PE': 'Peru (Spanish)',
        'en-PK': 'Pakistan (English)',
        'sv-SE': 'Sweden (Swedish)'

    },
    mapFetchifyCode: {
        'en-GB': 'GBR',
        de: 'DEU',
        'en-EG': 'EGP',
        'ar-EG': 'EGP',
        'en-US': 'USD',
        'fr-FR': 'EUR',
        'pl': 'PLN',
        'ar-AE': 'AED',
        'en-AE': 'AED',
    },
    mapLinks: {
        Wellbeing: {
            'en-GB': 'wellbeing-articles',
            de: 'dein-wohlbefinden',
        },
        Recipes: {
            'en-GB': 'recipes',
            de: 'rezepte',
        },
        News: {
            'en-GB': 'news',
            de: 'news',
        },
    },
    userCentric:{
        'en-EG': 'QasplMwig',
        'ar-EG': 'QasplMwig',
        'en-AE': 'F2srXR71P',
        'ar-AE': 'F2srXR71P',
        'es-PE': 'EzIQdpzlb',
        'en-PK': 'b5swL-w_2',
        'sv-SE': 'S-S9NAt8W'
    }
}